import { formValidationErrors } from './form-validation-error';

const SET_SUBMIT_FAILED = '@@redux-form/SET_SUBMIT_FAILED';

export default {
  [SET_SUBMIT_FAILED]: formValidationErrors,
};
